import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const routes: Array<any> = [];
const routerFiles = require.context("../views", true, /.vue$/);
routerFiles.keys().forEach(file => {
  const routePath = file
    .replace(/.vue/g, "")
    .replace(/.\//, "")
    .replace(/([A-Z])/g, str => {
      return "-" + str.toLowerCase();
    })
    .replace(/\/-/, "/");
  const routeName = file
    .split("/")
    [file.split("/").length - 1].replace(/.vue/, "");
  const vueUrl = file.replace(/.\//, "");
  routes.push({
    path: `/${routePath}`,
    name: routeName,
    // component: () => import(`../views/${vueUrl}`)
    component: (resolve: any) => require([`../views/${vueUrl}`], resolve)
  });
});
// console.log(routes);
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

router.addRoutes([
  {
    name: "404page",
    path: "*",
    component: () => import("../views/404/404.vue")
  }
]);

export default router;
